import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import StatusForm from "./ReceiverStatusForm";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { statusValidationForm } from "../../utils/validationSchemas";

const CreateStatus = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    control,
    watch,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(statusValidationForm),
  });
  const { handleCreate, statusList, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <StatusForm
        errors={errors}
        clearErrors={clearErrors}
        register={register}
        statusList={statusList}
        setValue={setValue}
        getValues={getValues}
        control={control}
        watch={watch}
      />
    </FormLayout>
  );
};

export default CreateStatus;
